import axios from '@/backend'
import _ from 'lodash'

const defaultState = () => {
  return {
    id: null,
    message_id: null,
    content: '',
    to_email: [],
    mailbox_id: null,
    cc: [],
    subject: '',
    status: null,
    attachments: []
  }
}

const state = {
  draft: {}
}

const getters = {
  draft (state) {
    return state.draft
  }
}

const mutations = {

  setDraft (state, {draft, parentMessageId}) {
    let newDraft = Object.assign({}, state.draft, draft)
    newDraft.to_email = extractEmails(newDraft.to_email)
    newDraft.cc = extractEmails(newDraft.cc)
    if (parentMessageId) {
      newDraft.message_id = parentMessageId
    }
    _.set(state, 'draft', newDraft)
  },

  setDefaultDraft (state) {
    _.set(state, 'draft', defaultState())
  }
}

const actions = {

  saveDraftMessage ({dispatch, commit}, {draft, parentMessageId}) {
    commit('setDraft', {draft: draft, parentMessageId: parentMessageId})
    if (state.draft.id) {
      dispatch('updateDraft')
    } else {
      dispatch('createDraft')
    }
  },

  updateDraft ({dispatch, commit}, autoSave) {
    return axios.put(`/message_drafts/${state.draft.id}`, {message_draft: state.draft})
      .then(response => {
        commit('setDraft', {draft: response.data})
        if (!autoSave) {
          dispatch('reloadMessage')
        }
      })
      .catch(e => { console.log(e.response) })
  },

  createDraft ({dispatch, commit}, autoSave) {
    return axios.post('/message_drafts', {message_draft: state.draft})
      .then(response => {
        commit('setDraft', {draft: response.data})
        if (!autoSave) {
          dispatch('reloadMessage')
        }
      })
      .catch(e => { console.log(e) })
  },

  deleteDraft ({dispatch, commit}, id) {
    // eslint-disable-next-line
    let draftId = id ? id : state.draft.id
    return axios.delete(`/message_drafts/${draftId}`)
      .then(response => {
        commit('setDraft', {draft: defaultState()})
        dispatch('reloadMessage')
      })
      .catch(e => { console.log(e) })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}

const extractEmails = (emails) => {
  return emails.map(email => {
    if (email.value) {
      return email.value
    } else if (email.label) {
      return email.label
    } else {
      return email
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/draft.js